import { render, staticRenderFns } from "./AuthorRow.vue?vue&type=template&id=0669d2b7&"
import script from "./AuthorRow.vue?vue&type=script&lang=js&"
export * from "./AuthorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports